import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Modal } from "../../components/modal";
import {
  ProcurementForm,
  ProcurementFormValues,
} from "../../components/procurement-form";
import {
  createProcurement,
  procurementFormValuesToCreate,
} from "../../services/procurement";
import { navigateBack } from "../../utils/navigate-back";

export function ProcurementCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const [formValues, setFormValues] = useState<ProcurementFormValues>({
    title: "",
    description: "",
    tags: [],
    organizations: [],
  });

  const closeModal = () => {
    navigateBack(navigate, "/admin/procurement/list");
  };

  return (
    <Modal open onClose={() => closeModal()}>
      <ProcurementForm
        hasError={hasError}
        loading={loading}
        values={formValues}
        onCancel={() => closeModal()}
        onChange={setFormValues}
        onSubmit={() => {
          (async () => {
            setLoading(true);
            try {
              await createProcurement(
                procurementFormValuesToCreate(formValues),
              );
              await queryClient.invalidateQueries({
                queryKey: ["procurements"],
              });
              closeModal();
            } catch {
              setHasError(true);
            } finally {
              setLoading(false);
            }
          })();
        }}
      />
    </Modal>
  );
}
